export default __webpack_public_path__ + "static/media/silver.5cd1c561.svg";